module.exports = __webpack_public_path__ + "static/media/varal-muro-removivel.53fae56d.jpg";